import { render } from "./About.vue?vue&type=template&id=5faa50d0"
const script = {}

import exportComponent from "D:\\Code\\word\\anyRTC\\anyrtc_synergy\\Synergy-Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__